export default "__VITE_ASSET__C$JlA8cO__"